import { useState, useCallback } from 'react'

const useToggle = (initialToggleValue = false) => {
    
    const [toggleValue, setToggleValue] = useState(initialToggleValue)
    const toggle = useCallback(
        () => {
            setToggleValue(toggleValue => !toggleValue)
        },
        [],
    )
    return [toggleValue ,toggle]
}
export default useToggle

